import TVideo from './video.vue'
export default TVideo



// WEBPACK FOOTER //
// ./src/components/video/index.js